import RequestStatus from '../model/RequestStatus';
import { ProgramFees, ProgramParam } from 'src/model/ProgramFees';
import { GetProgramFeesQueryComplete } from 'src/actions/ProgramFeesQueryAction';
import QueryProductInfo from 'src/model/QueryProduct';

export const NEW_PROGRAM_FEES_QUERY_START = 'NEW_PROGRAM_FEES_QUERY_START';
export const ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START =
  'ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START';
export const UPDATE_NEW_PROGRAM_FEES_QUERY_START =
  'UPDATE_NEW_PROGRAM_FEES_QUERY_START';
export const NEW_PROGRAM_FEES_QUERY_SUCCESS = 'NEW_PROGRAM_FEES_QUERY_SUCCESS';
export const NEW_PROGRAM_FEES_QUERY_FAILED = 'NEW_PROGRAM_FEES_QUERY_FAILED';
export const NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START =
  'NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START';
export const NEW_PROGRAM_FEES_WITH_TAXES_QUERY_SUCCESS =
  'NEW_PROGRAM_FEES_WITH_TAXES_QUERY_SUCCESS';
export const NEW_PROGRAM_FEES_WITH_TAXES_QUERY_FAILED =
  'NEW_PROGRAM_FEES_WITH_TAXES_QUERY_FAILED';

export interface NewProgramFeesQueryStartAction {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly countryCode: string;
  readonly queryProduct: QueryProductInfo;
  readonly programIdList: string[];
  readonly programParamMap?: Record<string, ProgramParam>;
  readonly isTaxEnabled?: boolean;
}

export const setNewProgramFeesQueryStart = (
  countryCode: string,
  queryProduct: QueryProductInfo,
  programIdList: string[],
  programParamMap?: Record<string, ProgramParam>,
): NewProgramFeesQueryStartAction => ({
  type: NEW_PROGRAM_FEES_QUERY_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  queryProduct,
  programIdList,
  programParamMap,
});

export const setNewProgramFeesQueryWithTaxesStart = (
  countryCode: string,
  queryProduct: QueryProductInfo,
  programIdList: string[],
  programParamMap?: Record<string, ProgramParam>,
  isTaxEnabled?: boolean,
): NewProgramFeesQueryStartAction => ({
  type: NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  queryProduct,
  programIdList,
  programParamMap,
  isTaxEnabled,
});

export const setAdditionalNewProgramFeesQueryStart = (
  countryCode: string,
  queryProduct: QueryProductInfo,
  programIdList: string[],
  programParamMap?: Record<string, ProgramParam>,
): NewProgramFeesQueryStartAction => ({
  type: ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  queryProduct,
  programIdList,
  programParamMap,
});

export const setUpdateNewProgramFeesQueryStart = (
  countryCode: string,
  queryProduct: QueryProductInfo,
  programIdList: string[],
  programParamMap?: Record<string, ProgramParam>,
): NewProgramFeesQueryStartAction => ({
  type: UPDATE_NEW_PROGRAM_FEES_QUERY_START,
  requestStatus: RequestStatus.UPDATING,
  countryCode,
  queryProduct,
  programIdList,
  programParamMap,
});

export const getNewProgramFeesQuerySuccessAction = (
  programIdList: string[],
  programFees: ProgramFees,
): GetProgramFeesQueryComplete => ({
  type: NEW_PROGRAM_FEES_QUERY_SUCCESS,
  requestStatus: RequestStatus.SUCCESS,
  programIdList,
  programFees,
});

export const getNewProgramFeesQueryFailedAction = (
  programIdList: string[],
): GetProgramFeesQueryComplete => ({
  type: NEW_PROGRAM_FEES_QUERY_FAILED,
  requestStatus: RequestStatus.ERROR,
  programIdList,
  programFees: null,
});

export const getNewProgramFeesWithTaxesQuerySuccessAction = (
  programIdList: string[],
  programFees: ProgramFees,
): GetProgramFeesQueryComplete => ({
  type: NEW_PROGRAM_FEES_WITH_TAXES_QUERY_SUCCESS,
  requestStatus: RequestStatus.SUCCESS,
  programIdList,
  programFees,
});

export const getNewProgramFeesWithTaxesQueryFailedAction = (
  programIdList: string[],
): GetProgramFeesQueryComplete => ({
  type: NEW_PROGRAM_FEES_WITH_TAXES_QUERY_FAILED,
  requestStatus: RequestStatus.ERROR,
  programIdList,
  programFees: null,
});
